<script>

/**
 * @typedef manifest { Object }
 * @property id { Number }
 * @property quantity { Boolean }
 * @property quantity_unit_id { Number }
 */
export default {
  name: "SelfEmissionQuantityInformation",
  components: {},
  mixins: [],
  props: {
    manifest: {
      type: Object,
      default: () => null
    },
    fromOrder: {
      type: Boolean,
      default: () => false
    },
    quantityUnits: {
      type: Array,
      default: () => {}
    },
    processType: {
      type: String,
      default: () => null
    },
  },
  data() {
    return {
      customMessages: {
        double: '{_field_}は半角数字のみ使用できます',
        regex: '{_field_}は整数5桁まで,小数3桁までで入力してください'
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>

<template>
  <div>
    <v-row dense class="pb-3">
      <v-col cols="12">
        <h3>数量情報</h3>
      </v-col>
    </v-row>

    <v-row dense>
      <!-- 数量 -->
      <v-col cols="6">
        <validation-provider
          v-slot="{ errors }"
          :custom-messages="customMessages"
          :disabled="!manifest.target_for_registration"
          :rules="{
            required: true,
            double: true,
            min_value: 0.001,
            max_value: 99999.999,
            quantityWithDecimal: { int_digits: 5, dec_digits: 3 }
          }"
          :vid="`quantity-${manifest.id}`"
          class="requiredMark"
          name="数量"
        >
          <v-text-field
            v-model="manifest.quantity"
            :disabled="!manifest.target_for_registration"
            :error-messages="errors"
            dense
            reverse
            hide-details="auto"
            label="数量"
            outlined
            persistent-placeholder
            type="number"
            @keydown.69.prevent
          />
        </validation-provider>
      </v-col>
      <!-- /数量 -->

      <!-- 単位 -->
      <v-col cols="6">
        <validation-provider
          v-slot="{ errors }"
          :disabled="!manifest.target_for_registration"
          :vid="`quantity_unit_id-${manifest.id}`"
          class="requiredMark"
          rules="required"
          name="単位"
        >
          <v-select
            v-model="manifest.quantity_unit_id"
            :disabled="!manifest.target_for_registration"
            :error-messages="errors"
            :items="quantityUnits"
            clearable
            dense
            hide-details="auto"
            label="単位"
            outlined
            persistent-placeholder
          />
        </validation-provider>
      </v-col>
      <!-- /単位 -->
    </v-row>
  </div>
</template>
